import { render, staticRenderFns } from "./EventEntry.vue?vue&type=template&id=383e62f8"
import script from "./EventEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./EventEntry.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EventEntry.vue?vue&type=style&index=0&id=383e62f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports